import { useEffect, useState, useCallback } from 'react';
import { Box } from '@mui/material';
import { Text } from 'mbd-components/text';
import { CountField } from './count_field';

export function MinMaxInput({heading, min, max, setMin, setMax}) {

    const [showMinMaxWarning, setShowMinMaxWarning] = useState(false);
    const [warningMessage, setWarningMessage] = useState('');
  
    useEffect(() => {
      validateRange();
    }, [min, max]);
  
    const handleMinChange = useCallback((e) => {
      validateRange();
      setMin(e.target.value);
    }, []);
  
    const handleMaxChange = useCallback((e) => {
      validateRange();
      setMax(e.target.value);
    }, []);
  
    const validateRange = () => {

      if (min === '' || max === '') return true;

      if (Number(min) <= Number(max)){
        setWarningMessage('');
        setShowMinMaxWarning(false);
      }
      else {
        setWarningMessage('min must be less than max');
        setShowMinMaxWarning(true);
      }

      if (Number(min) < 0 || Number(max)  < 0 || !Number.isInteger(Number(min)) || !Number.isInteger(Number(max))){
        setWarningMessage('min and max must be positive integers');
        setShowMinMaxWarning(true);
      }
  
    };
  
  
    return (
      <Box>
        <Box display="flex" gap={2} alignItems="center">
          <Text variant='fieldHeading' color='brand-light' sx={{mr:4, minWidth:80}}>{heading}</Text>
          <CountField id={heading + '-min-field'} horizontal heading="min" minWidth={40} headingColor='gray-light' value={min} onChange={handleMinChange}/>
          <Box ml={2}>
            <CountField id={heading + '-max-field'} horizontal heading="max" minWidth={40} headingColor='gray-light' value={max} onChange={handleMaxChange}/>
          </Box>
        </Box>
        {
          showMinMaxWarning &&
          <Box my={2} sx={{marginLeft: 24}}>
            <Text variant='warning' color='warning'>{warningMessage}</Text>
          </Box>
        }
      </Box>
  
    );
  }